import React, { useState } from 'react';
import { connect } from 'react-redux';
import { bindActionCreators, Dispatch } from 'redux';
import { Location } from 'history';
import { AuthClientInstance } from 'api/authClientInstance';

import {
  updatePasswordSuccess,
  resetPasswordError,
} from 'actions/authenticate';
import UpdatePassword from 'components/common/UpdatePassword';
import { translationString } from './translation';

interface IOwnProps {
  location: Location;
}

interface IDispatchProps {
  updatePasswordSuccess: () => void;
  resetPasswordError: (error: string) => void;
}

interface IStateProps {
  isUpdatePasswordSuccess: Nullable<boolean>;
  errorMessage: Nullable<string>;
}

type ResetPasswordType = IStateProps & IOwnProps & IDispatchProps;

const ResetPassword = (props: ResetPasswordType) => {
  const {
    updatePasswordSuccess,
    resetPasswordError,
    isUpdatePasswordSuccess,
    errorMessage,
    location,
  } = props;

  const [isSubmitting, setIsSubmitting] = useState<boolean>(false);
  const [language, setLanguage] = useState<string>('english');

  const updatePassword = async (newPassword: string, resetToken: string) => {
    try {
      setIsSubmitting(true);
      await AuthClientInstance.get().updatePassword({
        updatePasswordDTO: { token: resetToken, password: newPassword },
      });
      updatePasswordSuccess();
    } catch (e) {
      setIsSubmitting(false);
      resetPasswordError(e.response.data.message);
    }
  };

  return (
    <UpdatePassword
      isSubmitting={isSubmitting}
      updatePassword={updatePassword}
      updatePasswordSuccess={isUpdatePasswordSuccess}
      errorMessage={errorMessage}
      message={translationString.success[language]}
      location={location}
      language={language}
      setLanguage={setLanguage}
    />
  );
};

const mapStateToProps = (state: IRootStateType) => {
  return {
    isUpdatePasswordSuccess: state.authenticate.updatePasswordSuccess,
    errorMessage: state.authenticate.errorMessage,
  };
};

const mapDispatchToProps = (dispatch: Dispatch) =>
  bindActionCreators(
    {
      updatePasswordSuccess,
      resetPasswordError,
    },
    dispatch,
  );

export default connect(mapStateToProps, mapDispatchToProps)(ResetPassword);
